import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { IMainState } from './state';

const defaultState: IMainState = {
  isLoggedIn: null,
  token: '',
  logInError: false,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  state: {
    messages: [],
    user: '',
    response: {},
  },
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
